import React, { useState, useEffect, useCallback, useMemo } from 'react';
import { Modal, ModalHeader, Nav, NavItem, NavLink } from 'reactstrap';
import classnames from 'classnames';
import PowerGenerationSourceMaintenanceForm from '../Forms/PowerGenerationSourceMaintenanceForm';

const AddEditPowerGenerationSourceMaintenanceModal = ({
	dataPowerGenerationSource,
	isOpen,
	isEdit,
	handleToggleModal,
}) => {
	return (
		<Modal
			isOpen={isOpen}
			toggle={handleToggleModal}
			size='xl'
			className='border-0'
			modalClassName='modal fade zoomIn'
			backdrop={'static'}
			centered={true}
		>
			<ModalHeader toggle={handleToggleModal}>
				{isEdit ? 'Editar' : 'Agendar'} Mantención
			</ModalHeader>

			<PowerGenerationSourceMaintenanceForm
				dataPowerGenerationSource={dataPowerGenerationSource}
				isOpen={isOpen}
				isEdit={isEdit}
				handleToggleModal={handleToggleModal}
			/>
		</Modal>
	);
};

export default AddEditPowerGenerationSourceMaintenanceModal;
